import React, { useContext } from "react";
import { Modal, Box, Typography } from "@mui/material";
import ReferralsTable from "../../Tables/WcchcDashboard/ReferralsTable";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { WcchcPatientSummaryContext } from "../../../Contexts/wcchcPatientSummaryContext";

const useStyles = makeStyles((theme) => ({
  mainModalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "900px",
    height: (props) => props.height,
    backgroundColor: "#fff",
    maxHeight: "95vh",
    outline: "none",
    maxWidth: "95vw",
  },
  header: {
    padding: "11px 12px 9px 18px !important",
    borderBottom: "1px solid #000",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerTitle: {
    fontFamily: "Lato",
    fontSize: "20px !important",
    fontWeight: 600,
    lineHeight: "30px",
    letterSpacing: "-0.03em",
    color: "#0080b2",
  },
  headerIcon: {
    fill: "#0080b2",
    cursor: "pointer",
  },
  detailsContainer: {
    padding: "0px 20px !important",
    maxHeight: "calc(100% - 100px)",
    overflow: "hidden",
  },
}));

const ReferralsModal = ({ open, setReferralsModal }) => {
  const { state } = useContext(WcchcPatientSummaryContext);
  let height = state.tablesDataLength.referrals ? "611px" : "250px";
  const classes = useStyles({height});

  return (
    <Modal
      open={open}
      onClose={() => setReferralsModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableScrollLock={true}
    >
      <Box className={classes.mainModalContainer}>
        <Box className={classes.header}>
          <Typography className={classes.headerTitle}>Referrals</Typography>
          <Close
            onClick={() => setReferralsModal(false)}
            className={classes.headerIcon}
          />
        </Box>
        <Box className={classes.detailsContainer}>
          <ReferralsTable maxHeight={520} modal={true} />
        </Box>
      </Box>
    </Modal>
  );
};

export default ReferralsModal;
